import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
// import { registerLicense } from '@syncfusion/ej2-base';
import Main from './Main';
import ErrorBoundary from './ErrorBoundary';

// registerLicense('MTM4NTg3NUAzMjMwMmUzNDJlMzBTQ1IwQTB6cEMyaktJTzlVTFBqMVJjczFJRmFSUUp3YlNnYVhDVzFPMDRnPQ==;Mgo DSMBaFt/QHRqVVhkVFpHaV1KQmFJfFBmRGldeVR0dkU3HVdTRHRcQl5hSH5SckNnW35deHw=;Mgo DSMBMAY9C3t2VVhkQlFacldJXnxLdkx0RWFab196cFNMZF5BNQtUQF1hSn5QdERjWHtYdHZUQ2VV;Mgo DSMBPh8sVXJ0S0J XE9AflRBQmFBYVF2R2BJflR0cl9CYkwgOX1dQl9gSX1Rd0ViXXlacnVSRWg=;MTM4NTg3OUAzMjMwMmUzNDJlMzBYOXI2a3ZwdzRkejg0MTZaQmQvYi9JQ0dqYlBrM1ljS3VjYXVqNHY0V0Z3PQ==;NRAiBiAaIQQuGjN/V0Z WE9EaFtKVmBWfFtpR2NbfE5xflFAalhTVAciSV9jS31TdUdiWX5adnBXRGFfWA==;ORg4AjUWIQA/Gnt2VVhkQlFacldJXnxLdkx0RWFab196cFNMZF5BNQtUQF1hSn5QdERjWHtYdHZXRGZV;MTM4NTg4MkAzMjMwMmUzNDJlMzBSaTkvVUhCM0dJczdzS0pmaXlERnBaS1ErTjhINmhuZnRISyt3Qk9VbnJrPQ==;MTM4NTg4M0AzMjMwMmUzNDJlMzBvYi95aVYyN2FxeDhkNk9wTVZDTUd2V2FUb1ZMaTZRcWcxK010MXlNOUNBPQ==;MTM4NTg4NEAzMjMwMmUzNDJlMzBRNzlmVVFzSzRmR3lSVjV5M0tjUjFGano3cGxGa1M2Nm9raXhOS0hjV09RPQ==;MTM4NTg4NUAzMjMwMmUzNDJlMzBTS3M4WCtCdEcrN3p5eHlVQ2hDckN0TS9NZy9QMHFXN0NYM1c1U096bjVJPQ==;MTM4NTg4NkAzMjMwMmUzNDJlMzBTQ1IwQTB6cEMyaktJTzlVTFBqMVJjczFJRmFSUUp3YlNnYVhDVzFPMDRnPQ==');
window.rootContent = document.getElementById('root');
ReactDOM.render((
  <ErrorBoundary>
    <BrowserRouter basename={window.contextPath}>
      <Main />
    </BrowserRouter>
  </ErrorBoundary>), window.rootContent);

//TODO
//Check if there is a authToken in localstorage, else load login
//Ajax call to get user account
//  On failure , load Login
//  On success, 
//    Check users last projectID
//      if null, load projects page
//      if not null, load project management page




// WEBPACK FOOTER //
// src/index.js